import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon, DownloadIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';
import FormularioProducto from './FormularioProducto';

const TablaProductos: React.FC = () => {
  const { isOpen: isOpenVer, onOpen: onOpenVer, onClose: onCloseVer } = useDisclosure();
  const { isOpen: isOpenEditar, onOpen: onOpenEditar, onClose: onCloseEditar } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [artesanos, setArtesanos] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [busqueda, setBusqueda] = useState('');

  const fetchData = async () => {
    setCargando(true);
    try {
      const [res, resArt] = await Promise.all([
        axiosInstance.get('/turismo/productos'),
        axiosInstance.get('/turismo/artesanos'),
      ]);
      setData(res.data || []);
      setArtesanos(resArt.data || []);
    } catch {
      setData([]);
      setArtesanos([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const getArtesanoNombre = (id: number) => {
    const a = artesanos.find((x) => x.id === id);
    return a ? `${a.nombres} ${a.apellidos}` : id ? `ID ${id}` : '-';
  };

  const datosFiltrados = data.filter((item) =>
    busqueda
      ? item.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
        item.tipo?.toLowerCase().includes(busqueda.toLowerCase())
      : true
  );

  const handleVer = (item: any) => { setSelectedItem(item); onOpenVer(); };
  const handleEditar = (item: any) => { setSelectedItem(item); onOpenEditar(); };
  const handleGuardado = () => { onCloseNuevo(); onCloseEditar(); fetchData(); };
  const handleEliminar = async (item: any) => {
    const ok = window.confirm(`Eliminar el producto ${item.nombre}?`);
    if (!ok) return;
    try {
      await axiosInstance.delete(`/turismo/productos/${item.id}`);
      fetchData();
    } catch {
      // noop
    }
  };

  const handleCatalogo = () => {
    const base = axiosInstance.defaults.baseURL || '';
    window.open(`${base}/turismo/productos/catalogo/pdf`, '_blank');
  };

  return (
    <Box>
      <Flex mb={4} justify="space-between" align="center" flexWrap="wrap" gap={3}>
        <HStack spacing={3} flexWrap="wrap">
          <Input
            placeholder="Buscar por nombre o tipo..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            size="sm"
            w={{ base: 'full', md: '240px' }}
          />
        </HStack>
        <HStack spacing={2}>
          <Button size="sm" leftIcon={<DownloadIcon />} colorScheme="purple" variant="outline" onClick={handleCatalogo}>
            Catalogo PDF
          </Button>
          <Button size="sm" leftIcon={<AddIcon />} bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={onOpenNuevo}>
            Nuevo producto
          </Button>
        </HStack>
      </Flex>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Nombre</Th>
              <Th color="white" fontSize="xs">Tipo</Th>
              <Th color="white" fontSize="xs">Artesano</Th>
              <Th color="white" fontSize="xs">Precio ref.</Th>
              <Th color="white" fontSize="xs">Disponibilidad</Th>
              <Th color="white" fontSize="xs">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : datosFiltrados.length === 0 ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.400">Sin registros</Text></Td></Tr>
            ) : (
              datosFiltrados.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: '#f7efe8' }}>
                  <Td maxW="220px"><Text noOfLines={1} title={item.nombre}>{item.nombre}</Text></Td>
                  <Td>{item.tipo || '-'}</Td>
                  <Td>{getArtesanoNombre(item.artesanoId)}</Td>
                  <Td>{item.precioRef ? `$${Number(item.precioRef).toLocaleString('es-MX')}` : '-'}</Td>
                  <Td>{item.disponibilidad || '-'}</Td>
                  <Td>
                    <HStack spacing={1}>
                      <Button size="xs" colorScheme="blue" variant="outline" onClick={() => handleVer(item)}>Ver</Button>
                      <Button size="xs" colorScheme="orange" variant="outline" onClick={() => handleEditar(item)}>Editar</Button>
                      <Button size="xs" colorScheme="red" variant="outline" onClick={() => handleEliminar(item)}>Eliminar</Button>
                    </HStack>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpenVer} onClose={onCloseVer} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Detalle del producto</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioProducto modo="view" data={selectedItem} artesanos={artesanos} />}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
            <Button onClick={onCloseVer}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenEditar} onClose={onCloseEditar} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Editar producto</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioProducto modo="edit" data={selectedItem} artesanos={artesanos} onGuardado={handleGuardado} onCancelar={onCloseEditar} />}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Nuevo producto</ModalHeader>
          <ModalBody py={5} bg="white">
            <FormularioProducto modo="new" artesanos={artesanos} onGuardado={handleGuardado} onCancelar={onCloseNuevo} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaProductos;


